export default __webpack_public_path__ + "static/meshery-features-8401dfe269b0c7e5fbbed2ac813a708a.webp";